exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#headImage {\n  width: calc(100% + 80px);\n  background-color: #ad0e68;\n  position: relative;\n  padding-top: 28.5%; }\n  #headImage .image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    margin: 1em auto;\n    margin-top: 0px;\n    max-width: 720px; }\n  #headImage .image img {\n      min-width: 100%;\n      min-height: 100%;\n      position: relative;\n      top: 50%;\n      -webkit-transform: translateX(-50%) translateY(-50%);\n              transform: translateX(-50%) translateY(-50%);\n      left: 50%; }\n  .metadata {\n  font-size: 0.6em;\n  margin-bottom: 0.5em; }\n  .excerpt {\n  font-weight: bold;\n  margin-bottom: 0.5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/post/post.component.scss
// module id = ../../../../../src/app/post/post.component.scss
// module chunks = main